import { Container, VStack, Stack, Heading, Text } from '@chakra-ui/react';

export default function HeroWithStackedMedia({ title, subTitle, cta, media }) {
  return (
    <Container maxW={'7xl'}>
      <VStack
        align={'center'}
        spacing={{ base: 5 }} >
        <Stack>
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', lg: '4xl' }}>
            <Text align={'center'}>
              { title }
            </Text>
          </Heading>
          <Text whiteSpace={'pre-line'} align={'center'}>
            { subTitle }
          </Text>
        </Stack>
        <Stack
          flex={1}
          justify={'center'}
          align={'center'}
          position={'relative'}
          w={'full'}>
          { media }
        </Stack>
      </VStack>
    </Container>
  );
}
